import { useNavigate } from 'react-router-dom'
import { MainView } from '../components/layout/main'
import Sidebar from '../components/layout/sidebar/sidebar'
import { Page, PageHeader } from '../ui'
import { ViewThruAllBatchesView } from '../components/views/viewThruAllBatchesView'

export const VIEWTHRU_ALL_BATCHES_PATH = '/viewthru-batch/analysis'

function ViewThruAllBatches() {
    const navigate = useNavigate()
    return (
        <div className="viewThruBatch">
            <Sidebar />
            <MainView>
                <Page>
                    <PageHeader
                        eyebrow="Sentinel Tools"
                        title="ViewThru Batch Analysis"
                        intro="Combined eligibility analysis across every completed ViewThru batch."
                        backTo="/viewthru-batch"
                        backLabel="Back to batches"
                    />
                    <ViewThruAllBatchesView />
                </Page>
            </MainView>
        </div>
    )
}

export default ViewThruAllBatches
